<template>

  <div class="info-box" style="min-height:92.5vh">
    <campus-card :selectable="false"/>
  </div>
</template>

<script>
  import CampusCard from '@/views/components/CampusCard'
  export default {
    name: "myCard",
    data() {
      return {
      }
    },
    components: {
      // eslint-disable-next-line vue/no-unused-components
      CampusCard
    },
    methods: {
      back() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  .info-box {
    background: #ffffff;
  }

</style>
